import { FormControl, FormLabel, Grid, GridSize } from '@material-ui/core';
import { ReactElement, ReactNode } from 'react';
import useCommonStyles from '../../useCommonStyles';
import { OutlinedInputFieldProps } from './OutlinedInputField';

type DoubleChildren = [ReactElement<OutlinedInputFieldProps>, ReactElement<OutlinedInputFieldProps>];

type OutlinedDoubleInputFieldProps = {
    label: ReactNode;
    required?: boolean;
    disabled?: boolean;
    children: DoubleChildren;
    leftGrid?: GridSize;
    rightGrid?: GridSize;
};

const OutlinedDoubleInputField = ({
    label,
    required,
    disabled,
    children,
    leftGrid = 6,
    rightGrid = 6,
}: OutlinedDoubleInputFieldProps) => {
    const commonStyles = useCommonStyles();
    const [leftInput, rightInput] = children;

    return (
        <FormControl fullWidth>
            <FormLabel className={commonStyles.formLabel} disabled={disabled} required={required}>
                {label}
            </FormLabel>

            <Grid spacing={2} container>
                <Grid sm={leftGrid} xs={12} item>
                    {leftInput}
                </Grid>
                <Grid sm={rightGrid} xs={12} item>
                    {rightInput}
                </Grid>
            </Grid>
        </FormControl>
    );
};

export default OutlinedDoubleInputField;
